import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Isvg from 'react-inlinesvg';
import styleable from 'react-styleable';
import ExpandIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_expand.svg';

import css from './header-toggle.scss';

const HeaderToggle = ({ title, onClick, defaultExpanded }) => {
    const i18n = window.i18n;
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);
    const onClickHandler = () => {
        const updatedIsExpanded = !isExpanded;

        setIsExpanded(updatedIsExpanded);
        onClick(updatedIsExpanded);
    };

    return (
        <div className={css.container}>
            <span>{title}</span>
            <button onClick={onClickHandler}>
                <Isvg src={ExpandIcon} cacheGetRequests />
                <span>
                    {isExpanded ? i18n._('Collapse') : i18n._('Expand')}
                </span>
            </button>
        </div>
    );
};

HeaderToggle.propTypes = {
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    defaultExpanded: PropTypes.bool.isRequired
};

HeaderToggle.defaultProps = {
    onClick: () => {},
    defaultExpanded: false
};

export default styleable(css)(HeaderToggle);



// WEBPACK FOOTER //
// ./components/participation-table/header-toggle/header-toggle.js